import { HelpLink } from 'elements/link/HelpLink'
import { Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

export const RoleTitle = ({ record, translate, style }) => {
  return (
    <Typography style={style} variant="h5">
      {translate('Team Member:')} {record ? `"${record.display}"` : ''}
    </Typography>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Add team members from your company and set permissions.')}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12299933220111-How-to-create-custom-roles-and-add-team-members" />
    </span>
  )
}

export default {
  list: { lazy: () => import('./Roles'), component: 'RoleList' },
  edit: { lazy: () => import('./Roles'), component: 'RoleEdit' },
  create: { lazy: () => import('./Roles'), component: 'RoleCreate' },
  options: {
    create: {
      title: 'Invite Team Member',
      subtitle: null,
      breadCrumb: 'Invite Team Member',
    },
    list: {
      title: 'My Team Members',
      subtitle: <Subtitle />,
      breadCrumb: 'Team',
    },
    edit: {
      title: <RoleTitle />,
      subtitle: 'Manage details and permissions for your team member.',
      breadCrumb: 'Edit Team Member',
    },
  },
}
